import { render, staticRenderFns } from "./MyLayout.vue?vue&type=template&id=78fadb97&scoped=true&"
import script from "./MyLayout.vue?vue&type=script&lang=js&"
export * from "./MyLayout.vue?vue&type=script&lang=js&"
import style0 from "./MyLayout.vue?vue&type=style&index=0&id=78fadb97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fadb97",
  null
  
)

export default component.exports